export const TOGGLE = '/backoffice/modal/TOGGLE';


// WEBPACK FOOTER //
// ./src/store/modal/types.js